import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  SettingOutlined,
  UserOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  FileSyncOutlined,
  DashboardOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;
const { SubMenu } = Menu;

function Navigation() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  const menuItems = [
    {
      name: "Panel",
      icon: <DashboardOutlined />,
      link: "/",
      key: 1,
    },
    {
      name: "Usuarios",
      icon: <DashboardOutlined />,
      link: "/users",
      key: 1122,
    },
    {
      name: "Subir Docentes",
      icon: <DashboardOutlined />,
      link: "/uploadusers",
      key: 11222,
    },
    /*{
      name: "Steps",
      icon: <DashboardOutlined />,
      link: "/step",
      key: 11,
    },*/
    {
      name: "Grupos",
      icon: <CustomerServiceOutlined />,
      link: "/groups",
      key: 2221,
    },


    {
      name: "Diccionario",
      icon: <CustomerServiceOutlined />,
      link: "/dictionary",
      key: 46,
    },
    {
      name: "Examen Final",
      icon: <CustomerServiceOutlined />,
      link: "/assessment",
      key: 4,
    },
    {
      name: "Desafíos",
      icon: <CustomerServiceOutlined />,
      link: "/challenges-v2",
      key: 55,
    },

    {
      name: "Enigmas",
      icon: <CustomerServiceOutlined />,
      link: "/card",
      key: 154,
    },

    {
      name: "Dilema",
      icon: <CustomerServiceOutlined />,
      link: "/dilema",
      key: 54,
    },
    {
      name: "Datos maestros",
      icon: <SettingOutlined />,
      key: "sub1",
      children: [
        {
          name: "Carreras",
          icon: <CustomerServiceOutlined />,
          link: "/degree",
          key: 21,
        },
        {
          name: "Retroalimentaciones",
          icon: <CustomerServiceOutlined />,
          link: "/feedbacks",
          key: 2231,
        },
        {
          name: "Insignias",
          icon: <CustomerServiceOutlined />,
          link: "/badges",
          key: 5,
        },
        {
          name: "Cuestionarios",
          icon: <CustomerServiceOutlined />,
          link: "/questionnaire",
          key: 3,
        },
        {
          name: "Competencias",
          icon: <CustomerServiceOutlined />,
          link: "/competence",
          key: 2,
        },
        {
          name: "Competencias Transversales",
          icon: <CustomerServiceOutlined />,
          link: "/transversals",
          key: 2222,
        },
      ]
    }
    // {
    //   name: "Documentos",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/docs",
    //   key: 514,
    // },
    // {
    //   name: "Responses",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/response",
    //   key: 541,
    // },

    // {
    //   name: "Enigmas",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/enigma",
    //   key: 52,
    // },
    // {
    //   name: "Missions",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/mission",
    //   key: 53,
    // },

    // {
    //   name: "Cases",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/cases",
    //   key: 51,
    // },


    //
    // {
    //   name: "Avatar items",
    //   icon: <CustomerServiceOutlined />,
    //   link: "/avatar",
    //   key: 6,
    // }



  ];

  const getCurrentRoute = () => {
    var ret = ["1"];

    const searchKey = (items) => {
      items.forEach((item) => {
        if (item.link && location.pathname.includes(item.link)) {
          ret = ["" + item.key + ""];
        }
        if (item.children) {
          searchKey(item.children);
        }
      });
    };

    searchKey(menuItems);

    return ret;
  };


  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        style={{
          zIndex: 1000,
        }}
      >
        <div className="logo" />
        <Menu theme="dark" selectedKeys={getCurrentRoute()} mode="inline">
          {menuItems.map((menuItem) => {
            if (menuItem.children) {
              return (
                <SubMenu key={menuItem.key} icon={menuItem.icon} title={menuItem.name}>
                  {menuItem.children.map((subItem) => (
                    <Menu.Item key={subItem.key} icon={subItem.icon}>
                      <Link to={subItem.link}>{subItem.name}</Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            }
            return (
              <Menu.Item key={menuItem.key} icon={menuItem.icon}>
                <Link to={menuItem.link}>{menuItem.name}</Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>
    </>
  );
}
export default Navigation;
